import { UserLimits } from "@modules/core";
import { UserLimitsUtils } from "@utils";

const nameChangeWarning =
  "If you continue, you will lose your identity verification and any profession associated with that identity.";

/**
 * The warning shown before a verified user changes their full name. When the
 * workspace has disabled identity verification, the user can't verify again.
 */
export function getNameChangeWarningMessage(userLimits: UserLimits | null) {
  return UserLimitsUtils.isIdentityVerificationAvailable(userLimits)
    ? `${nameChangeWarning} You can verify your identity again later.`
    : `${nameChangeWarning} Your workspace has disabled identity verification, so you won't be able to verify again.`;
}
